import addIdleTask from './common/page-utils/idle';
import { perfLog } from './common/page-utils/perf';

export class PageUtils {
  constructor() {}
  init() {
    try {
      addIdleTask(this.initPerf);
    } catch (e) {
      console.error('Detail page utils init error:', e);
    }
  }
  initPerf() {
    return perfLog();
  }
}

export default function getPageUtils() {
  if (window.__globalUtils__) {
    return window.__globalUtils__;
  }
  window.__globalUtils__ = new PageUtils();
  return window.__globalUtils__;
}
